import { urlCookieIframe, cookieDomodiMessageName, cookieDomodiUserId, cookieDomodiSession, urlCookieSet } from './api';
import util from './utils/util';

(function (window) {
    const IFRAME_SRC = urlCookieIframe;
    const MESSAGE_NAME = cookieDomodiMessageName;

    const CookieNames = {
        USER_ID: cookieDomodiUserId,
        SESSION: cookieDomodiSession
    };

    class CookieSet {
        constructor() {
            this.userIdCookie = util.getCookie(CookieNames.USER_ID);
            const sessionCookie = util.getCookie(CookieNames.SESSION);

            if (!this.userIdCookie || !sessionCookie) {
                this.createPixel();
                this.addListeners();
            }
        }

        createPixel() {
            const image = new Image(1, 1);
            image.src = urlCookieSet;

            image.addEventListener('load', this.createIframe);
        }

        createIframe() {
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', IFRAME_SRC);
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';

            document.body.appendChild(iframe);
        }

        receiveMessage(e) {
            if (e.data && e.data.name === MESSAGE_NAME) {
                const userId = e.data.userId;
                util.setCookie(CookieNames.SESSION, 1);

                if (userId !== this.userIdCookie) {
                    util.setCookie(CookieNames.USER_ID, userId, 365);
                }
            }
        }

        addListeners() {
            window.addEventListener('message', this.receiveMessage.bind(this));
        }
    }

    new CookieSet();
})(window);
